import { render } from "./RoleIndex.vue?vue&type=template&id=21db71e2&ts=true"
import script from "./RoleIndex.vue?vue&type=script&lang=ts"
export * from "./RoleIndex.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__